import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import { FaRegStar, FaStar } from "react-icons/fa";
import { Dropzone, FileMosaic } from "@files-ui/react";
import FieldInput from "../../Components/FieldInput";
import { useFormik } from "formik";
import * as Yup from 'yup'
import { useSelector } from "react-redux";
import Button from "../../Components/Button";

const initialReviewForm = {
    starRating: 0,
    headline: '',
    images: [],
    review: '',
}

const ProductReview = ({ match }) => {

    const [productDetails, setProductDetails] = useState()
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hoveredStar, setHoveredStar] = useState(0);
    const [selectedStar, setSelectedStar] = useState(0);
    const userDetails = useSelector((state) => state.auth.userDetails)
    const [thankDisplay, setThankDisplay] = useState(false)

    useEffect(() => {
        try {
            setLoading(true)
            API.get(`/products/getProductById/${match.params.productId}`).then((prodRes) => {
                setProductDetails(prodRes.data.data)
                setLoading(false)
            })
        } catch (err) {
            console.log(err)
        }
    }, [])

    const reviewFormSchema = Yup.object().shape({
        starRating: Yup.number().required('Star rating is required'),
        headline: Yup.string().required('Headline is required'),
        images: Yup.array(),
        review: Yup.string().required("Review is required"),
    })

    const reviewForm = useFormik({
        initialValues: initialReviewForm,
        validateOnMount: true,
        enableReinitialize: true,
        validationSchema: reviewFormSchema,
        onSubmit: (values) => {
            values.starRating = selectedStar
            values.images = files
            values.productId = match.params.productId
            values.reviewedBy = userDetails.subject._id
            const formData = new FormData();
            formData.append('reviewData', JSON.stringify(values));
            files.forEach((file) => {
                formData.append('files', file.file);
            });
            // Excellent products with over comfy which it nice fits to the baby. And it is excellent fit to my car
            API.post('/products/reviewProduct', formData).then((reviewRes) => {
                if (reviewRes.status === 200) {
                    setThankDisplay(true)
                }
            })
        }
    })

    const updateFiles = (incommingFiles) => {
        //do something with the files
        setFiles(incommingFiles);
        //even your own upload implementation
    };
    const removeFile = (id) => {
        setFiles(files.filter((x) => x.id !== id));
    };


    const handleMouseEnter = (index) => {
        setHoveredStar(index);
    };

    const handleMouseLeave = () => {
        setHoveredStar(0);
    };

    const handleClick = (index) => {
        setSelectedStar(index);
    };

    const clearReviewScreen = () => {
        setSelectedStar(0);
        reviewForm.resetForm()
        setFiles([])
    }

    return (
        <>
            {
                loading ? "Loading please wait..." : !thankDisplay ? <motion.div className="relative h-full w-full flex flex-col md:px-20 px-2">
                    <motion.div className="text-xl font-bold text-black">
                        Create Review
                    </motion.div>
                    <motion.div className="grid grid-cols-1 gap-10 my-5">
                        <motion.div className="flex flex-row">
                            <motion.div className="bg-white drop-shadow-md">
                                <img src={productDetails.imageData[0].imageUrl} height={100} width={100} />
                            </motion.div>
                            <motion.div className="text-md items-center flex flex-row justify-center  mx-2 font-bold text-grey">
                                {productDetails.productData.productName}&nbsp;/&nbsp;{productDetails.productData.brandName}&nbsp;/&nbsp;{productDetails.productData.modelName}
                            </motion.div>
                        </motion.div>
                        <motion.div className="text-black font-bold my-2">
                            Add Rating
                            <motion.div className="flex flex-row my-2">
                                {[1, 2, 3, 4, 5].map((index) => (
                                    <div
                                        key={index}
                                        className="mx-1 text-2xl cursor-pointer"
                                        onMouseEnter={() => handleMouseEnter(index)}
                                        onMouseLeave={handleMouseLeave}
                                        onClick={() => handleClick(index)}
                                    >
                                        {index <= (hoveredStar || selectedStar) ? (
                                            <FaStar className="text-yellow-500" />
                                        ) : (
                                            <FaRegStar className="text-gray-400" />
                                        )}
                                    </div>
                                ))}
                            </motion.div>
                        </motion.div>
                        <FieldInput outerInjectClass={'px-0'} labelInjectClass={'px-0'} label={'Headline'} fieldHelper={reviewForm.getFieldHelpers('headline')} fieldMeta={reviewForm.getFieldMeta('headline')} fieldProps={reviewForm.getFieldProps('headline')} edit={true} dataLoaded={true} />
                        <motion.div className="text-black font-bold">
                            Upload images
                            <Dropzone className="relative my-2"
                                onChange={updateFiles}
                                value={files}
                                accept="image/*"
                            >
                                {files.map((file) => (
                                    <FileMosaic preview={true} key={file.id} {...file} onDelete={removeFile} info />
                                ))}
                            </Dropzone>
                        </motion.div>
                        <FieldInput outerInjectClass={'px-0'} labelInjectClass={'px-0'} label={'Review'} type="textarea" fieldHelper={reviewForm.getFieldHelpers('review')} fieldMeta={reviewForm.getFieldMeta('review')} fieldProps={reviewForm.getFieldProps('review')} edit={true} dataLoaded={true} />
                        <motion.div className="flex flex-row w-full justify-center">
                            <motion.div className="flex flex-row">
                                <Button injectClass={'bg-black/30 text-black font-bold cursor-pointer rounded-md'} onClick={() => clearReviewScreen()}>Cancel</Button>
                                <Button injectClass={'bg-black text-white font-bold cursor-pointer rounded-md'} onClick={() => reviewForm.submitForm()}>Submit</Button>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                </motion.div> : <motion.div className="flex flex-col justify-center relative h-full w-full px-2 md:px-20">
                    <motion.div className="flex flex-row justify-center text-center w-full">
                        Thanks for your response.
                    </motion.div>
                </motion.div>
            }
        </>
    )
}

export default ProductReview